import { useState } from 'react';
import { ChevronLeft, ChevronRight, Eye, EyeOff, BadgePercent, Wallet } from 'lucide-react';
import { getAffiliateUrl } from '../data/affiliateLinks';
import { propFirmLogos } from '../data/propFirmLogos';
import { getDiscountInfo } from '../utils/pricing';

function HeroCarouselCard({ firm, onPrev, onNext }) {
  const [revealCode, setRevealCode] = useState(false);
  const discount = firm.evaluation.discount;

  const { discountedPrice, savings, percentage } = getDiscountInfo(
    firm.evaluation.fee,
    discount?.percent
  );

  return (
    <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 backdrop-blur-md p-6 sm:p-8 rounded-2xl text-white shadow-xl w-full max-w-md border border-yellow-700">
      <div className="flex items-center gap-4 mb-4">
        <div className="bg-black p-2 rounded-lg">
          <img src={propFirmLogos[firm.id]?.logo} alt={firm.name} className="w-12 h-12 object-contain" />
        </div>
        <div>
          <div className="font-bold text-lg text-yellow-400">{firm.name}</div>
          <div className="text-sm text-yellow-300">
            {firm.features.maxFunding} • Payout up to {firm.features.profitSplit}
          </div>
        </div>
      </div>

      <div className="mb-4 text-center">
        <div className="inline-flex items-center gap-2 text-yellow-400 font-extrabold text-2xl">
          <BadgePercent className="w-6 h-6 text-yellow-400" /> Save {percentage}% Today!
        </div>
      </div>

      <div className="text-sm space-y-1 text-center mb-6">
        <div className="line-through text-yellow-700">Original Price: ${firm.evaluation.fee.toFixed(2)}</div>
        <div className="text-yellow-300 text-xl font-bold">Promo Price: ${discountedPrice.toFixed(2)}</div>
        <div className="text-yellow-400 font-semibold flex justify-center items-center gap-1">
          <Wallet className="w-4 h-4" /> You Save: ${savings.toFixed(2)}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-2 mb-4">
        {revealCode ? (
          <a
            href={getAffiliateUrl(firm.id)}
            target="_blank"
            rel="noopener"
            className="flex-1 bg-yellow-400 text-black font-semibold px-4 py-3 rounded-full inline-flex items-center justify-center gap-2 hover:bg-yellow-300 transition text-center"
          >
            {discount.code}
            <EyeOff className="w-4 h-4" />
          </a>
        ) : (
          <button
            onClick={() => setRevealCode(true)}
            className="flex-1 bg-yellow-400 text-black font-semibold px-4 py-3 rounded-full inline-flex items-center justify-center gap-2 hover:bg-yellow-300 transition text-center"
          >
            Click to reveal code
            <Eye className="w-4 h-4" />
          </button>
        )}

        <a
          href={`/reviews/${firm.id}`}
          className="flex-1 bg-white text-yellow-700 py-3 rounded-full font-semibold text-center hover:bg-yellow-100 transition"
        >
          Read Review
        </a>
      </div>

      <div className="flex justify-center gap-4">
        <button
          onClick={onPrev}
          className="bg-white text-blue-800 rounded-full w-10 h-10 flex items-center justify-center shadow-md hover:bg-blue-50 transition"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={onNext}
          className="bg-white text-blue-800 rounded-full w-10 h-10 flex items-center justify-center shadow-md hover:bg-blue-50 transition"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}

export default HeroCarouselCard;
